<template>
  <gw-card class="a7-dashlet-visao-evolucao">
    <h2 slot="header">{{titulo}}</h2>
    <a7-visao-evolucao-chart
      slot="body"
      :filterParams="filterParams"
      :medidas="medidas"
      :tipo="tipo"/>
  </gw-card>
</template>

<script>
import {
  GwCard
} from 'guaxinim-web';
import A7VisaoEvolucaoChart from '../visao/A7VisaoEvolucaoChart';

export default {
  name: 'a7-dashlet-visao-evolucao',
  components: {
    GwCard,
    A7VisaoEvolucaoChart
  },
  props: {
    titulo: {
      type: String,
      required: true
    },
    medidas: {
      type: Array,
      required: true
    },
    tipo: {
      type: String,
      default: 'barra',
      validator: (valor) => ['barra', 'linha'].indexOf(valor) !== -1
    }
  },
  data() {
    return {
      filterParams: {}
    }
  },
  methods: {
    setFilterParams(filterParams) {
      this.filterParams = filterParams;
    }
  },
  created() {
    this.$parent.$on('filterParams', this.setFilterParams);
  },
  beforeDestroy() {
    this.$parent.$off('filterParams');
  }
}
</script>

<style lang="scss" scoped>
</style>
